/**
 * Defines an interface to use with views intended to be encapsulated in
 * Bootstrap modals. Sets className and defines a closeDialog function. Assumes
 * you are using Bootstrap modal classes and that the View you extend has
 * a 'destroy' method which, presumably, cleans up the DOM, like Marionette
 * Views do.
 *
 * Usage:
 *
 * DialogInterface = require('path/to/interfaces/dialog');
 * MyDialog = Marionette.View
 *          .extend(DialogInterface)
 *          .extend({
 *              // Your code here
 *          });
 *
 */
import _ from 'underscore';
import $ from 'jquery';

    export default {
        attributes: {
            tabindex: '-1'
        },
        className: 'modal fade',
        closeDialog: function() {
            this.$el.modal('hide');
        },
        // This should be called from the initialize function of any view that
        // implements this interface, to guarantee it is destroyed after being hidden.
        destroyOnClose: function() {
            // If we simply call modal('hide') in an before:destroy handler (which
            // generally is the proper way to manage cleanup on a destroy call), the
            // element is removed from the DOM before various CSS and JS visual
            // effects from Bootstrap can take place. Therefore we wait until the
            // bootstrap effect has completed before actually calling destroy.
            this.$el.on('hidden.bs.modal', _.bind(function() {
                this.destroy();
            }, this));
        },
        focusFirstInput: function() {
            this.$el.on('shown.bs.modal', _.bind(function() {
                this.$('input[type="text"]:enabled, input[type="password"]:enabled, input[type="email"]:enabled, textarea:enabled').first().focus();
            }, this));
        },
        onAttach: function() {
            if (this.prevent_dismiss) {
                this.$el.modal({backdrop: 'static', keyboard: false});
            }
            this.$el.modal('show');
        },
        showAlert: function(type, response) {
            var alert = this.$el.find('.alert');
            var alertContainer = this.$('.modal-alert-container');
            var css_class = 'alert-danger';

            switch (type) {
                case 'success':
                    css_class = 'alert-success';
                    break;
                case 'failure':
                    css_class = 'alert-danger';
                    break;
                case 'warning':
                    css_class = 'alert-warning';
                    break;
            }

            alert.removeClass('alert-success alert-danger hidden');

            alert.addClass(css_class);

            let error_message = '';

            if ( response && response.responseJSON ) {
                response.responseJSON.errors.forEach( (e)=>{
                    // dt "detail type" what typeof returns for the
                    // detail part of the error response object
                    let detail_type = typeof e.detail;
                    switch ( detail_type ) {
                        case 'string' :
                            error_message = error_message +  e.detail;
                            break;
                        case 'object' :
                            error_message = error_message + e.detail.message;
                            break;
                    }
                });
            } else {
                error_message = response;
            }

            alert.text(error_message).show();
            alertContainer.slideDown('fast');
        },
        handle_error: function(response, message){
            var error = message || response.responseJSON.errors[0].detail;
            this.$('.loader').hide();
            this.showAlert.call(this, 'alert-danger', error);
        },
        hideAlert: function() {
            var alertContainer = $('.modal-alert-container');

            var alert = this.$el.find('.alert');
            alert.addClass('hidden');
            alertContainer.slideUp('fast');
        },
        check_validation: function (element, max_length, max_length_counter, submit_btn) {
            if ( element.val() === 0 ) return false;
            var length = element.val().length || 0;
            max_length_counter.text(length + ' / ' + max_length);

            if (submit_btn && length > 0 && length <= max_length) {
                submit_btn.prop('disabled', false);
            } else if (submit_btn) {
                submit_btn.prop('disabled', true);
            }
            if (length === max_length) {
                element.addClass('has-error-animation');
                element.on('animationend', function(){
                    element.removeClass('has-error-animation');
                });
            }
            return length < max_length;
        },
        custom_validation: function(element, validate_function, animate){
            if (!validate_function()){
                if (animate) {
                    element.addClass('has-error-animation');
                    element.on('animationend', function () {
                        element.removeClass('has-error-animation');
                    });
                    return false;
                } else {
                    element.addClass('has-error');
                    return false;
                }
            } else {
                element.removeClass('has-error');
                element.removeClass('has-error-animation');
                return true;
            }
        },
    };

